import React from 'react'
import {
  SimpleForm,
  required,
  Create,
  useNotify,
  useRedirect,
  SelectInput,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import { ColorPicker, Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
        initialValues={{
          stylesheet: [
            { type: 'primary' },
            { type: 'gradient_start' },
            { type: 'gradient_end' },
          ],
        }}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Inserir Novo Tema
                </Typography>
                <hr />
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'stylesheets.type'}>
                    <SelectInput
                      fullWidth
                      label="Tipo"
                      source="type"
                      choices={[
                        { id: 'banner', name: 'Banner' },
                        { id: 'popup', name: 'Popup' },
                      ]}
                      validate={[required('Obrigatório')]}
                      resettable
                      externalLoading={false}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`Cor dada aos botões e títulos do curso. `}
                  </Typography>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Tooltip title={'stylesheets.value'}>
                      <ColorPicker
                        fullWidth
                        label="Cor primária"
                        source="stylesheet[0].value"
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`Cor dada aos botões e títulos do curso. `}
                  </Typography>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Tooltip title={'stylesheets.value'}>
                      <ColorPicker
                        fullWidth
                        label="Degradê - cor inicial"
                        source="stylesheet[1].value"
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    {`Cor dada aos botões e títulos do curso. `}
                  </Typography>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Tooltip title={'stylesheets.value'}>
                      <ColorPicker
                        fullWidth
                        label="Degradê - cor final"
                        source="stylesheet[2].value"
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
